import { Breadcrumb, Card, Col, EventHandler, Label, OutlineButton, PrimaryButton, ReactSelectBox, Row, Search, SofturaTable, Tooltip } from "client/CommonComponents"
import './ActiveAssetRegisters.scss';
import excel from '../../../assets/images/Excel.svg'
import { FilteringMode } from 'ka-table/enums';
import { DatePicker } from "rsuite"
import moment from "moment";

const ActiveAssetRegister = ({
    breadcrumlist,
    handleChange,
    regionDropDownList,
    selectedRegion,
    activeAssetRegisterColumn,
    marketDropDownList,
    selectedMarket,
    costCenterDropdownList,
    selectedCostCenter,
    onClickExport,
    searchOptions,
    globalSearchBy,
    handleFilterClear,
    fetchAction,
    setFilters,
    serverTotal,
    pagesCount,
    onSearchOrder,
    onGlobalSearchByChange,
    searchBoxValue,
    showGrid,
    isGridDataLoading,
    activeAssetGridData,
    handleSearchGrid,
    alreadyHasGridFilterValues,
    isReport,
    selectedDate,
    handleDateChange,
    validStartDate,
    validEndDate,
    lastRefreshedDate,
    gridRemountKey
}: any) => {
    return (<div className="active-asset-register-container DropDownAlligment">
        <div className='breadcrumb'>
            <div className='order-1'><Breadcrumb items={breadcrumlist} maxDisplayedItems='5'  data-attribute="ActiveAssetRegisters_Default_Breadcrumb" /></div>
        </div>
        <div className="mb-3">
            <Card data-attribute="ActiveAssetRegisters_Default_Card">
                <div className='create-new-order-container'>
                    <div className='grid-block pt-2'>
                        <div className='my-1'>
                            <p className='headingText mb-2'>{!isReport ? 'ACTIVE ASSETS' : 'ACTIVE ASSETS REGISTER REPORT - ALL ASSETS'}</p>
                            <Row className="pe-xl-4 Active_Asset_leadr">
                                <Col xs={12} sm={12} md={4} lg={3} xl={3} className='mb-md-0 mb-3'>
                                    <Label data-attribute="ActiveAssetRegisters_Default_Label">Region</Label>
                                    <ReactSelectBox
                                        name='region'
                                        placeholder='Select Region'
                                        options={regionDropDownList}
                                        value={selectedRegion ?? ''}
                                        isSearchable={true}
                                        onChange={(value: any) => handleChange(value, 'region')}  data-attribute="ActiveAssetRegisters_region_SearchSelectBox" />
                                </Col>
                                {selectedRegion && marketDropDownList?.length ?
                                    <Col xs={12} sm={12} md={4} lg={3} xl={3} className='mb-md-0 mb-3'>
                                        <Label data-attribute="ActiveAssetRegisters_Default_Label_2">Market</Label>
                                        <ReactSelectBox
                                            name='market'
                                            placeholder='Select Market'
                                            options={marketDropDownList}
                                            value={selectedMarket ?? ''}
                                            isSearchable={true}
                                            onChange={(value: any) => handleChange(value, 'market')}  data-attribute="ActiveAssetRegisters_market_SearchSelectBox" />
                                    </Col>
                                    : null}
                                {selectedRegion && selectedMarket && costCenterDropdownList?.length ?
                                    <Col xs={12} sm={12} md={4} lg={3} xl={3} className='mb-md-0 mb-3 active_costcenter'>
                                        <Label data-attribute="ActiveAssetRegisters_Default_Label_3">Cost Center</Label>
                                        <ReactSelectBox
                                            name='costCenter'
                                            placeholder='Select Cost Center'
                                            options={costCenterDropdownList}
                                            onChange={(value: any) => handleChange(value, 'costCenter')}
                                            value={selectedCostCenter ?? ''}
                                            isSearchable={true}
                                            className='mb-3'
                                         data-attribute="ActiveAssetRegisters_costCenter_SearchSelectBox" />
                                    </Col>
                                    : null}

                                <Col xs={12} sm={12} md={12} lg={1} xl={1} className="active_clear_search searchbtns_activereport p-0">
                                    <Col >
                                        <OutlineButton onClick={handleSearchGrid} text='Search'  data-attribute="ActiveAssetRegisters_Default_Button" />
                                    </Col>
                                    <Col className="clear-filter me-2 me-lg-2 me-md-2 me-sm-0" >
                                        <PrimaryButton onClick={handleFilterClear} text='Clear Filters' disabled={alreadyHasGridFilterValues()}  data-attribute="ActiveAssetRegisters_Default_Button_2" />
                                    </Col>
                                </Col>
                            </Row>
                            <div className='clearfix mt-sm-2 mt-md-3 mt-lg-3 search_activereport'>
                                <div className='pull-left searchblock global-search'>
                                    <Label className='mb-0' data-attribute="ActiveAssetRegisters_Default_Label_4">Search By</Label>
                                    <div className='search-dropdown-block'>
                                        <ReactSelectBox
                                            name='globalSearch'
                                            options={searchOptions}
                                            value={globalSearchBy}
                                            onChange={onGlobalSearchByChange}
                                            className='global-search-drop-down'
                                         data-attribute="ActiveAssetRegisters_globalSearch_SearchSelectBox" />
                                        <Tooltip content={searchBoxValue ?? '-'}  data-attribute="ActiveAssetRegisters_Default_Tooltip">
                                            <Search
                                                placeholder={`Search By ${globalSearchBy?.label}`}
                                                className='searchTextbox'
                                                onSearch={(e?: any) => onSearchOrder(e, true)}
                                                onBlur={(e?: any) => onSearchOrder(e, false)}
                                                onChange={(e?: any) => onSearchOrder(e, false)}
                                                value={searchBoxValue}
                                             data-attribute="ActiveAssetRegisters_Default_Searchbox" />
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className='pull-right mb-2 mb-sm-0 excel-container'>
                                    {isReport && (
                                        <>

                                            <div className="DatePicker_ActiveReport">
                                                <div className="lastrefresh_date">
                                                    <label className="date_label">
                                                        Data Last Refreshed Date : {lastRefreshedDate ? moment(lastRefreshedDate).format('MM/DD/YYYY') : '-'}
                                                    </label>
                                                </div>
                                                <label className="date_label">
                                                    Month End Filter
                                                </label>
                                                <DatePicker
                                                    format="MMM-yyyy"
                                                    placeholder="MMM-YYYY"
                                                    onChange={(value: any) => handleDateChange(value)}
                                                    value={selectedDate ? new Date(selectedDate) : null}
                                                    shouldDisableDate={(date) => {
                                                        // Disable dates outside the valid range
                                                        return moment(date).isAfter(validEndDate, 'month') || moment(date).isBefore(validStartDate, 'month');
                                                    }}
                                                    calendarDefaultDate = {selectedDate ? new Date(selectedDate) : new Date()}
                                                    limitStartYear={ moment(validStartDate)?.year() === moment(validEndDate)?.year() ? 1 : 2}  // Adjust based on valid start and end years
                                                    limitEndYear={1}  // Limit to the current year for the end date
                                                />
                                            </div>
                                        </>
                                    )}
                                    {!isGridDataLoading && (
                                        <div className='excel-section-active-asset'>
                                            <EventHandler onEvent={(e?: any) => onClickExport(e)} data-attribute="ActiveAssetRegisters_Default_EventHandler">
                                                <img src={excel} alt='excel' />
                                            </EventHandler>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {showGrid ?
                            <div className={`${activeAssetGridData?.length != 0 ? "softura-table pe-0" : "softura-table paginationNav pe-0"}`}>
                                <SofturaTable
                                    key={gridRemountKey}
                                    data={activeAssetGridData ?? []}
                                    columns={activeAssetRegisterColumn}
                                    sort={true}
                                    defaultPageSize={10}
                                    pageSizes={[10, 20, 50]}
                                    globalSearch={false}
                                    filter={true}
                                    fixedHeader={true}
                                    defaultPaginationPosition={"Both"}
                                    className={`order-listing-grid`}
                                    filteringMode={FilteringMode.FilterRow}
                                    getFilterValue={setFilters}
                                    serverTotal={serverTotal}
                                    fetchAction={fetchAction}
                                    isServerSide={true}
                                    pagesCount={pagesCount}
                                    loading={isGridDataLoading}
                                 data-attribute="ActiveAssetRegisters_Default_Grid" />
                            </div>
                            : null}
                    </div>
                </div>
            </Card>
        </div>
    </div>)
}

export default ActiveAssetRegister